/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_Csv_MenuInputs */

const en_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export as CSV`)
};

const fr_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter en CSV`)
};

const de_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als CSV exportieren`)
};

const it_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta come CSV`)
};

const ru_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт в формате CSV`)
};

const es_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar como CSV`)
};

const zh_cn2_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出为 CSV 文件`)
};

const ja_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSVとしてエクスポート`)
};

const hi_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV फ़ाइल के रूप में निर्यात करें`)
};

const pt_pt2_markers_export_csv_menu = /** @type {(inputs: Markers_Export_Csv_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar como CSV`)
};

/**
* | output |
* | --- |
* | "Export as CSV" |
*
* @param {Markers_Export_Csv_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_csv_menu = /** @type {((inputs?: Markers_Export_Csv_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_Csv_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_export_csv_menu(inputs)
	if (locale === "de") return de_markers_export_csv_menu(inputs)
	if (locale === "it") return it_markers_export_csv_menu(inputs)
	if (locale === "ru") return ru_markers_export_csv_menu(inputs)
	if (locale === "es") return es_markers_export_csv_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_export_csv_menu(inputs)
	if (locale === "ja") return ja_markers_export_csv_menu(inputs)
	if (locale === "hi") return hi_markers_export_csv_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_export_csv_menu(inputs)
	return en_markers_export_csv_menu(inputs)
});